<div  class="card profileDetail">
    <div class="d-flex flex-wrap">
        <div class="profileimage">
            <div class="image">
                <img
                [src]="(profileImage == null || profileImage == '')? '/assets/images/user.svg' : profileImage"
                alt="">
                <div class="btn-camera">
                  <input #myFileInput2 type="file" (click)="clearFile($event)" (change)="onSelect($event)" id="imgProfile2" style="display:none" accept="image/png, image/jpeg" />
                  <label for="imgProfile2" class="changeIcon pointer p-a"><span class="material-symbols-outlined icon-light"> add_a_photo </span></label>
              </div>
            </div>
            <div class="verifySection text-center">
                <div *ngIf="isverifyBtn" class="badge badge-success text mb-2 ">Approved</div>
                <button class="btn btn-block btn-primary"  [routerLink]="['/auth/changepassword', this.UserId]"> Change
                  Password</button><br>
            </div>
        </div>
     
    </div>
</div>